// extracted by mini-css-extract-plugin
export default {"DocumentTypeAction":"DocumentTypeAction_DocumentTypeAction"};